import React from 'react'
import "./CustomViewImage.css"
import { Button, Modal } from 'react-bootstrap';

function CustomViewImage(props) {

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = props.src;
    link.download = 'image.jpg'; // اسم الملف
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Modal
      {...props}
      size="lg"
      centered
    >


      <Modal.Body>
        <img src={props.src} alt='' className='w-75' />

        <div className="mt-3">
          <Button variant="primary" onClick={handleDownload}>
            تحميل الصورة
          </Button>
                <Button 
        variant="danger" 
        onClick={props.onHide} 
        className='close_btn mx-2'
      >
أغلق
      </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default CustomViewImage